/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 11:26:35
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginCarousel from 'bee-carousel';
//require('bee-carousel/build/Carousel.css');
import { Carousel as OriginCarousel } from '@tinper/next-ui';

export default class Carousel extends Component {
    prev = () => {
        this.carousel.prev();
    }

    next = () => {
        this.carousel.next();
    }

    goTo = (slideNumber, dontAnimate) => {
        this.carousel.goTo(slideNumber, dontAnimate);
    }

    render() {
        return <OriginCarousel {...this.props} ref={carousel => this.carousel = carousel} />;
    }
}
